import colors from 'common/styles/colors';
import {
  MachineCloneStatusEnum,
  normalizeMachineCloneStatus
} from 'common/constants/machineCloneStatus';

const getThemeColors = theme => (theme && theme.colors) || colors;

export const cloneStatusTheme = (status, theme) => {
  const themeColors = getThemeColors(theme);

  switch (normalizeMachineCloneStatus(status)) {
    case MachineCloneStatusEnum.COMPLETED:
      return {
        backgroundColor: themeColors.cloneStatusCompletedBackground,
        color: themeColors.cloneStatusCompletedText,
      };
    case MachineCloneStatusEnum.IN_PROGRESS:
      return {
        backgroundColor: themeColors.cloneStatusInProgressBackground,
        color: themeColors.cloneStatusInProgressText,
      };
    case MachineCloneStatusEnum.FAILED:
      return {
        backgroundColor: themeColors.cloneStatusFailedBackground,
        color: themeColors.cloneStatusFailedText,
      };
    case MachineCloneStatusEnum.SKIPPED:
      return {
        backgroundColor: themeColors.cloneStatusSkippedBackground,
        color: themeColors.cloneStatusSkippedText,
      };
    case MachineCloneStatusEnum.PENDING:
    default:
      return {
        backgroundColor: themeColors.cloneStatusPendingBackground,
        color: themeColors.cloneStatusPendingText,
      };
  }
};
